import { FC } from "react";

import { HourglassAnimateIcon } from "../../../../../icons";
import TrendChart from "../../../../../TrendChart/TrendChart";
import { CardPreviewProps } from "./types";

import styles from "./CardPreview.module.css";



const CardPreview: FC<CardPreviewProps> = ({ name, scores }) => {
  return (
    <div className={styles["card-preview"]}>
      <h4 className={styles["card-preview__title"]}>{name}</h4>
      <div className={styles["card-preview__score"]}>
        {scores.length > 1 ?
          <TrendChart score={scores} strokeWidth={4} /> :
          <><HourglassAnimateIcon /> <p>Calculating...</p></>}
      </div>
    </div>
  );
};

export default CardPreview;